import { useEffect } from "react";
import { Outlet, useNavigate } from "@tanstack/react-router";

import { useOptionalSession } from "@/lib/session";
import { LoadingState } from "@/components/LoadingState";

export function AuthenticatedLayout() {
  const session = useOptionalSession();
  const navigate = useNavigate();

  useEffect(() => {
    if (session === null) {
      const returnTo = window.location.pathname + window.location.search;
      navigate({
        to: "/login",
        search: { return_to: returnTo },
        replace: true,
      });
    }
  }, [session, navigate]);

  if (session === null) return <LoadingState />;

  return <Outlet />;
}
